import { useFileDownload } from '@/hooks/useFileDownload';
import { useTenants } from '@/services/tenants/useTenants';

export interface PartFinderExportSelection {
  reportIds?: string[];
  batchIds?: string[];
}

export const usePartFinderExport = () => {
  const { getTenantId } = useTenants();
  const { download, isDownloading } = useFileDownload();

  const exportToExcel = (selection: PartFinderExportSelection) =>
    download(`/tenants/${getTenantId()}/part-finder/reports/export`, {
      method: 'POST',
      body: { reportIds: selection.reportIds ?? [], batchIds: selection.batchIds ?? [] },
      filename: 'part-finder-export.xlsx',
      errorMessage: 'Failed to export reports',
    });

  return { exportToExcel, isExporting: isDownloading };
};
